import styled, {css} from 'styled-components';
import {NavLink} from 'react-router-dom';

interface ItemProps {
  readonly dcolor?: string;
  readonly xmargin?: string;
  readonly texttransform?: string;
}

export const TabContainer = styled.section`
  display: inline-flex;
  justify-content: center;
`;

export const TabItem = styled(NavLink)<ItemProps>`
  text-decoration: none;
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 10px;
  text-align: center;
  text-transform: ${props => props.texttransform};

  ${props => {
    const dcolor = `color: ${props.dcolor};`;
    const xmargin = `
      margin-left: ${props.xmargin};
      margin-right: ${props.xmargin};
    `;

    return css`
       {
        ${dcolor}
        ${xmargin}
      }
    `;
  }}
`;

export const TabTitle = styled.span`
  margin-left: 4px;
  color: inherit;
`;
